module.exports = {
      id: "return-usage",
      viewBox: "0 0 25.442 23.678",
      url: "img/" + "sprite.svg#return-usage",
      toString: function () {
        return this.url;
      }
    }